import { camelize } from '@ember/string';

import { singularize } from '@warp-drive/utilities/string';
import Service from 'ember-can/services/abilities';

import { getRecordType } from 'umg-ember-backend/utils/get-record-type';

export default class AbilitiesService extends Service {
  can(abilityString, modelOrRecordType, properties) {
    let model =
      typeof modelOrRecordType === 'string' ? null : modelOrRecordType;
    let recordType = model ? getRecordType(model) : modelOrRecordType;
    let propertyName = camelize(abilityString);
    let abilityName = singularize(recordType);

    return !!this.valueFor(propertyName, abilityName, model, {
      ...properties,
      recordType,
    });
  }

  canAccess(transition) {
    let segments = transition.to?.name?.split('.') ?? [];
    const isLoading = segments.includes('loading');
    const isError = segments.includes('error');
    const isAdmin = segments.includes('admin');
    const action = segments.slice(-1)[0] === 'new' ? 'create' : 'read';

    if (isLoading || isError || !isAdmin || transition.isAborted) {
      return true;
    }

    const ignored = ['index', 'new'];
    segments = segments.filter((segment) => !ignored.includes(segment));

    const recordType = singularize(segments.slice(-1)[0]);

    return this.can(action, recordType);
  }

  cannotAccess(transition) {
    return !this.canAccess(transition);
  }
}
